var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      attrs: {
        width: _vm.getNavWidth(),
        height: _vm.getNavHeight(),
        right: "",
        absolute: "",
        temporary: "",
        clipped: "",
        overflow: "",
        app: ""
      },
      model: {
        value: _vm.showDrawer,
        callback: function($$v) {
          _vm.showDrawer = $$v
        },
        expression: "showDrawer"
      }
    },
    [
      _c("SideContent", {
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("button", { class: _vm.$style.pastOrdersClose }, [
                  _vm._v("\n        Past orders\n        "),
                  _c("span", { class: _vm.$style.upButton }, [
                    _c("svg", {
                      directives: [{ name: "svg", rawName: "v-svg" }],
                      class: _vm.$style.chevronDownIcon,
                      attrs: { symbol: "chevron-down" }
                    })
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "main",
            fn: function() {
              return [
                !_vm.isKioskPlatform && _vm.user
                  ? _c("div", { class: _vm.$style.pastOrdersWelcome }, [
                      _c("h4", { class: _vm.$style.welcomeTitle }, [
                        _vm._v(
                          "\n          Welcome Back, " +
                            _vm._s(_vm.user.firstName) +
                            "!\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v("Here’s your last 5 orders")])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { class: _vm.$style.pastOrdersTitle }, [
                  _c("h4", [
                    _c("span", [_vm._v("MY PAST ORDER")]),
                    _vm._v("S")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Up to 5 past orders")])
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { class: _vm.$style.ordersList },
                  _vm._l(_vm.lastFiveOrders, function(order, index) {
                    return _c("Order", {
                      key: index,
                      attrs: { order: order },
                      on: { "save-to-cart": _vm.saveToCart }
                    })
                  }),
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [_vm.isKioskPlatform ? _c("KioskTryBlock") : _vm._e()]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/cart/components/PastOrders.vue?vue&type=template&id=36442a95&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&
// module id = null
// module chunks = 